<style scoped>
  a:link {
    text-decoration: none;
  }
  a:hover {
    text-decoration: underline;
  }

</style>

<template>
  <v-footer
    app
    padless
    absolute
    color="rgba(255,255,255, 0.0)"
  >
    <v-col
      class="text-center grey--text caption"
      cols="12"
    >
      Copyright © {{ new Date().getFullYear() }} | Reddit Watch — Reddit Video Downloader | 
      <router-link
        active-class=""
        to="/privacy"
      >
        <span class="grey--text">Privacy Policy</span>
      </router-link>
      |
      <router-link
        active-class=""
        to="/tos"
      >
        <span class="grey--text">Terms of Service</span>
      </router-link>
      <br>
      Reddit Watch is not affiliated with Reddit Inc. or reddit.com
    </v-col>
  </v-footer>
</template>

<script>
export default {
  data: () => ({
  }),
};
</script>
